import COMPARISON_EVENTS from '@Core/controllers/vehicleComparisonController/eventNames';
import { breakpoints } from '@Front/constants';

export default class FacetedSearch {
  constructor(container) {
    this.container = container;
    this.topElement = container.querySelector(
      '.floating-elements__comparisons',
    );
  }

  attachListeners() {
    window.addEventListener(COMPARISON_EVENTS.ACTIVE, () => {
      this.container.dataset.comparisonsActive = 'true';
    });

    window.addEventListener(COMPARISON_EVENTS.MAXIMIZED, () => {
      this.container.dataset.comparisonsMaximized = 'true';
    });

    window.addEventListener(COMPARISON_EVENTS.MINIMIZED, () => {
      this.container.dataset.comparisonsMaximized = 'false';
    });

    window.addEventListener(COMPARISON_EVENTS.INACTIVE, () => {
      this.container.dataset.comparisonsActive = 'false';
    });
  }

  active() {
    return this.container.dataset.comparisonsActive === 'true';
  }

  maximized() {
    return this.container.dataset.comparisonsMaximized === 'true';
  }

  minimized() {
    return !this.maximized();
  }

  topEdgePosition() {
    if (!this.active()) {
      return 0;
    }

    if (this.minimized() && window.innerWidth >= breakpoints['break-3']) {
      return 0;
    }

    const padding = getComputedStyle(this.topElement)
      .getPropertyValue('padding-top')
      .replace('px', '') || 0;

    return this.topElement.getBoundingClientRect().height - parseFloat(padding);
  }

  mount() {
    this.attachListeners();
    return this;
  }
}
